// extracted by mini-css-extract-plugin
export default {"title":"form-control_title__jE6Zg","subTitle":"form-control_subTitle__fCVsH"};